// BUSINESS //
import BusinessAffiliation from 'pages/Business/Affiliations';
import AnnoncesCandidats from 'pages/Business/AnnoncesCandidats';
import DashboardBusiness from 'pages/Business/Dashboard';
import BusinessDocuments from 'pages/Business/Documents';
import EditVitrineBusiness from 'pages/Business/EditVitrine';
import MailboxBusiness from 'pages/Mailbox';
import NotificationsBusiness from 'pages/Business/Notifications';
import PartnersBusiness from 'pages/Business/Partner';
import SettingsBusiness from 'pages/Business/settings';
import InviteStudentBusiness from 'pages/Business/TeamsPages/Invite';
import Team from 'pages/Business/TeamsPages';
import AbandonedStudentBusiness from 'pages/Business/TeamsPages/Team/Components/AbandonedStudentBusiness';
import ExcluStudentBusiness from 'pages/Business/TeamsPages/Team/Components/ExcluStudentBusiness';
import StudentHistoriqueBusiness from 'pages/Business/TeamsPages/Team/Components/StudentHistorique';
import TeamDetail from 'pages/Business/TeamsPages/TeamDetail';
import VitrineBusiness from 'pages/Business/Vitrine';
import Cvtheque from 'pages/Cvtheque';
import FAQ from 'pages/FAQ';
import MyMap from 'pages/MyMap';
import GoogleAuth from 'pages/OAuth/Google';
import LinkedInAuth from 'pages/OAuth/LinkedIn';
// SCHOOL //
import SchoolAffiliation from 'pages/school/Affiliations';
import ClassesSchool from 'pages/school/ClassesPage/Classes';
import AbandonedStudent from 'pages/school/ClassesPage/Classes/Components/AbandonedStudent';
import ExcluStudent from 'pages/school/ClassesPage/Classes/Components/ExcluStudent';
import StudentHistorique from 'pages/school/ClassesPage/Classes/Components/StudentHistorique';
import ClassesDetail from 'pages/school/ClassesPage/ClassesDetail';
import InviteStudentSchool from 'pages/school/ClassesPage/Invite';
import ClassesShare from 'pages/school/ClassesPage/ClassesShare';
import DashboardSchool from 'pages/school/Dashboard';
import SchoolDocuments from 'pages/school/Documents';
import EditVitrineSchool from 'pages/school/EditVitrine';
import FormationsCandidats from 'pages/school/FormationsCandidats';
import MailboxSchool from 'pages/Mailbox';
import NotificationsSchool from 'pages/school/Notifications';
import PartnersSchool from 'pages/school/Partner';
import SettingsSchool from 'pages/school/settings';
import Vitrine from 'pages/school/Vitrine';
import SchoolConnections from 'pages/school/Connections';
// GENERAL //
import SignIn from 'pages/SignIn/index';
import SignUp from 'pages/Signup';
import ConfirmSignUp from 'pages/Signup/ConfirmSignUp';
import InviteExternal from 'pages/Invite/External';
// STUDENT //
import AcceptInvitation from 'pages/student/AcceptInvitation';
import Candidatures from 'pages/student/Candidatures';
import DashboardStudent from 'pages/student/Dashboard';
import StudentDocuments from 'pages/student/Documents';
import Favorites from 'pages/student/Favorites';
import Mailbox from 'pages/Mailbox';
import NotificationsStudent from 'pages/student/Notifications';
import ProfilStudent from 'pages/student/profil';
import SettingsStudent from 'pages/student/settings';
import Souscription from 'pages/student/Souscription';
// CFA //
import DashboardCFA from 'pages/CFA/Dashboard';
import SettingsCFA from 'pages/CFA/settings';
import Organismes from 'pages/CFA/Organismes';

import { ACCESSES, ROUTES_PATH } from './constants';
import CVStudent from 'pages/student/Cv';
import PlanningStudent from 'pages/student/Planning';
import Records from 'pages/CFA/Records';
import Accounting from 'pages/CFA/Accounting';
import Convention from 'pages/CFA/Convention';

const routes = [
  {
    path: ROUTES_PATH.SIGN_UP,
    component: SignUp,
    auth: true,
    exact: true,
  },
  {
    path: ROUTES_PATH.SIGN_IN,
    component: SignIn,
    auth: true,
    exact: true,
  },
  {
    path: ROUTES_PATH.LINKEDIN_OAUTH,
    component: LinkedInAuth,
    auth: true,
    exact: true,
  },
  {
    path: ROUTES_PATH.GOOGLE_OAUTH,
    component: GoogleAuth,
    auth: true,
    exact: true,
  },
  {
    path: ROUTES_PATH.CONFIRM_SIGNUP,
    component: ConfirmSignUp,
    auth: true,
    exact: true,
  },
  {
    path: ROUTES_PATH.SHARE_CLASSROOM,
    component: ClassesShare,
    exact: true,
  },
  {
    path: ROUTES_PATH.INVITE_EXTERNAL,
    component: InviteExternal,
    exact: true,
  },
  // ------------------------------------------- //
  // ----- SCHOOL ------------------------------ //
  // ------------------------------------------- //
  {
    path: ROUTES_PATH.SCHOOL_DASHBOARD,
    component: DashboardSchool,
    exact: true,
    accesses: [ACCESSES.SCHOOL],
  },
  {
    path: ROUTES_PATH.SCHOOL_FORMATIONS_CANDIDATS,
    component: FormationsCandidats,
    exact: true,
    accesses: [ACCESSES.SCHOOL],
  },
  {
    path: ROUTES_PATH.SCHOOL_VITRINE,
    component: Vitrine,
    exact: true,
    accesses: [ACCESSES.SCHOOL, ACCESSES.STUDENT, ACCESSES.BUSINESS, ACCESSES.CFA],
  },
  {
    path: ROUTES_PATH.EDIT_SCHOOL_VITRINE,
    component: EditVitrineSchool,
    exact: true,
    accesses: [ACCESSES.SCHOOL],
  },
  {
    path: ROUTES_PATH.SCHOOL_PARTNERS,
    component: PartnersSchool,
    exact: true,
    accesses: [ACCESSES.SCHOOL],
  },
  {
    path: ROUTES_PATH.CVTHEQUE_SCHOOL,
    component: Cvtheque,
    exact: true,
    accesses: [ACCESSES.SCHOOL],
  },
  {
    path: ROUTES_PATH.SCHOOL_SETTINGS,
    component: SettingsSchool,
    exact: true,
    accesses: [ACCESSES.SCHOOL],
  },
  {
    path: ROUTES_PATH.SCHOOL_CLASSES,
    component: ClassesSchool,
    exact: true,
    accesses: [ACCESSES.SCHOOL],
  },
  {
    path: ROUTES_PATH.SCHOOL_CLASSES_DETAIL,
    component: ClassesDetail,
    exact: true,
    accesses: [ACCESSES.SCHOOL],
  },
  {
    path: ROUTES_PATH.SCHOOL_DOCUMENT,
    component: SchoolDocuments,
    exact: true,
    accesses: [ACCESSES.SCHOOL],
  },
  {
    path: ROUTES_PATH.SCHOOL_AFFILIATION,
    component: SchoolAffiliation,
    exact: true,
    accesses: [ACCESSES.SCHOOL],
  },
  {
    path: ROUTES_PATH.SCHOOL_MESSAGES,
    component: MailboxSchool,
    exact: true,
    accesses: [ACCESSES.SCHOOL],
  },
  {
    path: ROUTES_PATH.SCHOOL_INVITE_STUDENT,
    component: InviteStudentSchool,
    exact: true,
    accesses: [ACCESSES.SCHOOL],
  },
  {
    path: ROUTES_PATH.STUDENT_EXCLUD,
    component: ExcluStudent,
    exact: true,
    accesses: [ACCESSES.SCHOOL],
  },
  {
    path: ROUTES_PATH.STUDENT_ABANDONED,
    component: AbandonedStudent,
    exact: true,
    accesses: [ACCESSES.SCHOOL],
  },
  {
    path: ROUTES_PATH.STUDENT_CLASS_HISTORIQUE,
    component: StudentHistorique,
    exact: true,
    accesses: [ACCESSES.SCHOOL],
  },
  {
    path: ROUTES_PATH.SCHOOL_NOTIFICATIONS,
    component: NotificationsSchool,
    exact: true,
    accesses: [ACCESSES.SCHOOL],
  },
  {
    path: ROUTES_PATH.SCHOOL_FAQ,
    component: FAQ,
    exact: true,
    accesses: [ACCESSES.SCHOOL],
  },
  {
    path: ROUTES_PATH.SCHOOL_CONNECTIONS,
    component: SchoolConnections,
    exact: true,
    accesses: [ACCESSES.SCHOOL],
  },
  // ------------------------------------------- //
  // ----- STUDENT ----------------------------- //
  // ------------------------------------------- //
  {
    path: ROUTES_PATH.STUDENT_DASHBOARD,
    component: DashboardStudent,
    exact: true,
    accesses: [ACCESSES.STUDENT],
  },
  {
    path: ROUTES_PATH.STUDENT_PROFIL,
    component: ProfilStudent,
    exact: true,
    accesses: [ACCESSES.STUDENT],
  },
  {
    path: ROUTES_PATH.STUDENT_PLANNING,
    component: PlanningStudent,
    exact: true,
    accesses: [ACCESSES.STUDENT],
  },
  {
    path: ROUTES_PATH.STUDENT_SOUSCRIPTION,
    component: Souscription,
    exact: true,
    accesses: [ACCESSES.STUDENT],
  },
  {
    path: ROUTES_PATH.STUDENT_SETTINGS,
    component: SettingsStudent,
    exact: true,
    accesses: [ACCESSES.STUDENT],
  },
  {
    path: ROUTES_PATH.STUDENT_CANDIDATURES,
    component: Candidatures,
    exact: true,
    accesses: [ACCESSES.STUDENT],
  },
  {
    path: ROUTES_PATH.STUDENT_FAVORITES,
    component: Favorites,
    exact: true,
    accesses: [ACCESSES.STUDENT],
  },
  {
    path: ROUTES_PATH.STUDENT_DOCUMENTS,
    component: StudentDocuments,
    exact: true,
    accesses: [ACCESSES.STUDENT],
  },
  {
    path: ROUTES_PATH.MYMAP,
    component: MyMap,
    exact: true,
    accesses: [ACCESSES.STUDENT],
  },
  {
    path: ROUTES_PATH.MAP_SCHOOL,
    component: MyMap,
    exact: true,
    accesses: [ACCESSES.SCHOOL],
  },
  {
    path: ROUTES_PATH.MAP_BUSINESS,
    component: MyMap,
    exact: true,
    accesses: [ACCESSES.BUSINESS],
  },
  {
    path: ROUTES_PATH.ACCEPT_INVIT,
    component: AcceptInvitation,
    exact: true,
  },
  {
    path: ROUTES_PATH.STUDENT_MESSAGES,
    component: Mailbox,
    exact: true,
    accesses: [ACCESSES.STUDENT],
  },
  {
    path: ROUTES_PATH.STUDENT_NOTIFICATIONS,
    component: NotificationsStudent,
    exact: true,
    accesses: [ACCESSES.STUDENT],
  },
  {
    path: ROUTES_PATH.STUDENT_FAQ,
    component: FAQ,
    exact: true,
    accesses: [ACCESSES.STUDENT],
  },
  // {
  //   path: ROUTES_PATH.STUDENT_SETTINGS,
  //   component: SettingsStudent,
  //   exact: true,
  //   accesses: [ACCESSES.STUDENT],
  // },
  // ------------------------------------------- //
  // ----- BUSINESS ---------------------------- //
  // ------------------------------------------- //
  {
    path: ROUTES_PATH.BUSINESS_DASHBOARD,
    component: DashboardBusiness,
    exact: true,
    accesses: [ACCESSES.BUSINESS],
  },
  {
    path: ROUTES_PATH.BUSINESS_VITRINE,
    component: VitrineBusiness,
    exact: true,
    accesses: [ACCESSES.BUSINESS, ACCESSES.SCHOOL, ACCESSES.STUDENT, ACCESSES.CFA],
  },
  {
    path: ROUTES_PATH.BUSINESS_ANNONCES_CANDIDATS,
    component: AnnoncesCandidats,
    exact: true,
    accesses: [ACCESSES.BUSINESS],
  },
  {
    path: ROUTES_PATH.EDIT_Business_VITRINE,
    component: EditVitrineBusiness,
    exact: true,
    accesses: [ACCESSES.BUSINESS],
  },
  {
    path: ROUTES_PATH.BUSINESS_PARTNERS,
    component: PartnersBusiness,
    exact: true,
    accesses: [ACCESSES.BUSINESS],
  },
  {
    path: ROUTES_PATH.CVTHEQUE_BUSINESS,
    component: Cvtheque,
    exact: true,
    accesses: [ACCESSES.BUSINESS],
  },
  {
    path: ROUTES_PATH.BUSINESS_SETTINGS,
    component: SettingsBusiness,
    exact: true,
    accesses: [ACCESSES.BUSINESS],
  },
  {
    path: ROUTES_PATH.BUSINESS_TEAMS,
    component: Team,
    exact: true,
    accesses: [ACCESSES.BUSINESS],
  },
  {
    path: ROUTES_PATH.BUSINESS_TEAMS_DETAIL,
    component: TeamDetail,
    exact: true,
    accesses: [ACCESSES.BUSINESS],
  },
  {
    path: ROUTES_PATH.BUSINESS_DOCUMENT,
    component: BusinessDocuments,
    exact: true,
    accesses: [ACCESSES.BUSINESS],
  },
  {
    path: ROUTES_PATH.BUSINESS_AFFILIATION,
    component: BusinessAffiliation,
    exact: true,
    accesses: [ACCESSES.BUSINESS],
  },
  {
    path: ROUTES_PATH.BUSINESS_MESSAGES,
    component: MailboxBusiness,
    exact: true,
    accesses: [ACCESSES.BUSINESS],
  },
  {
    path: ROUTES_PATH.BUSINESS_INVITE_STUDENT,
    component: InviteStudentBusiness,
    exact: true,
    accesses: [ACCESSES.BUSINESS],
  },
  {
    path: ROUTES_PATH.BUSINESS_STUDENT_EXCLUD,
    component: ExcluStudentBusiness,
    exact: true,
    accesses: [ACCESSES.BUSINESS],
  },
  {
    path: ROUTES_PATH.BUSINESS_STUDENT_ABANDONED,
    component: AbandonedStudentBusiness,
    exact: true,
    accesses: [ACCESSES.BUSINESS],
  },
  {
    path: ROUTES_PATH.BUSINESS_STUDENT_HISTORIQUE,
    component: StudentHistoriqueBusiness,
    exact: true,
    accesses: [ACCESSES.BUSINESS],
  },
  {
    path: ROUTES_PATH.BUSINESS_NOTIFICATIONS,
    component: NotificationsBusiness,
    exact: true,
    accesses: [ACCESSES.BUSINESS],
  },
  {
    path: ROUTES_PATH.BUSINESS_FAQ,
    component: FAQ,
    exact: true,
    accesses: [ACCESSES.BUSINESS],
  },
  // ------------------------------------------- //
  // ----- CFA --------------------------------- //
  // ------------------------------------------- //
  {
    path: ROUTES_PATH.CFA_DASHBOARD,
    component: DashboardCFA,
    exact: true,
    accesses: [ACCESSES.CFA],
  },
  {
    path: ROUTES_PATH.CFA_ORGANISMES,
    component: Organismes,
    exact: true,
    accesses: [ACCESSES.CFA],
  },
  {
    path: ROUTES_PATH.CFA_ACCOUNTING,
    component: Accounting,
    exact: true,
    accesses: [ACCESSES.CFA],
  },
  {
    path: ROUTES_PATH.CFA_RECORDS,
    component: Records,
    exact: true,
    accesses: [ACCESSES.CFA],
  },
  {
    path: ROUTES_PATH.CFA_CONTRACT,
    component: Convention,
    exact: true,
    accesses: [ACCESSES.CFA],
  },
  {
    path: ROUTES_PATH.MAP_CFA,
    component: MyMap,
    exact: true,
    accesses: [ACCESSES.CFA],
  },
  {
    path: ROUTES_PATH.CFA_NOTIFICATIONS,
    component: NotificationsSchool,
    exact: true,
    accesses: [ACCESSES.CFA],
  },
  {
    path: ROUTES_PATH.CFA_FAQ,
    component: FAQ,
    exact: true,
    accesses: [ACCESSES.CFA],
  },
  {
    path: ROUTES_PATH.CFA_MESSAGES,
    component: MailboxSchool,
    exact: true,
    accesses: [ACCESSES.CFA],
  }, 
  {
    path: ROUTES_PATH.CFA_SETTINGS,
    component: SettingsCFA,
    exact: true,
  }
];

export default routes;
